import React from 'react';
import {Helmet} from 'react-helmet';

type PageMetaProps = {
  title: string;
  description: string;
  path: string;
};

const getSiteOrigin = () =>
  typeof window !== 'undefined' ? window.location.origin : 'https://app.al.fan';

const PageMeta = ({title, description, path}: PageMetaProps) => {
  const origin = getSiteOrigin();
  const url = `${origin}${path}`;
  const image = `${origin}/logo512.png`;
  const fullTitle = title.includes('Alfan') ? title : `${title} | Alfan`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Alfan" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default PageMeta;
